import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import { relativeDate } from 'utils/datetime'
import {
  requestBuilds,
  getBuilds,
  restartBuild,
  restartFailedBuilds,
} from 'ducks/admin/builds'
import Page from 'components/Shared/Page'
import Loading from 'components/Shared/Loading'
import EmptyState from 'components/Shared/EmptyState'
import WrappedSelect from 'components/Shared/Forms/WrappedSelect'

class Build extends Component {
  state = { restarting: false }

  handleRestart = async () => {
    const { build, onRestart } = this.props

    this.setState({ restarting: true })

    try {
      await onRestart(build.id)
    } catch (err) {
      // Do something
    }

    this.setState({ restarting: false })
  }

  render() {
    const { build } = this.props
    const { restarting } = this.state

    return (
      <div className="admin-user-item">
        <h5>
          <Link to={`/apps/${build.AppId}`}>{build.App?.name}</Link>
        </h5>
        <p>{build.target}</p>
        <p>
          {build.version} ({build.versionCode})
        </p>
        <p>{relativeDate(build.updatedAt)}</p>
        <p className="admin-build-status-wrapper">
          <span
            className={classNames(
              'admin-build-status',
              `admin-build-${build.status}`
            )}
          >
            {build.status}
          </span>
          {build.status === 'failed' && (
            <a className="deemphasize" onClick={this.handleRestart}>
              Restart
            </a>
          )}
          {restarting && <Loading small />}
        </p>
      </div>
    )
  }
}

class Builds extends Component {
  componentDidMount() {
    const { requestBuilds } = this.props

    requestBuilds()
  }

  state = {
    target: 'all',
    hoursBack: 24,
  }

  setTarget = value => {
    this.setState({ target: value })
  }

  triggerRestart = () => {
    const { restartFailedBuilds } = this.props
    const { target, hoursBack } = this.state

    if (!hoursBack) {
      return
    }

    const timeFrom = new Date(
      Date.now() - hoursBack * 60 * 60 * 1000
    ).toISOString()

    restartFailedBuilds(timeFrom, target === 'all' ? null : target)
  }

  render() {
    const { builds, restartBuild } = this.props
    const { target, hoursBack } = this.state

    const targetOptions = [
      { value: 'all', label: 'All' },
      { value: 'ios', label: 'iOS' },
      { value: 'android', label: 'Android' },
    ]

    const filteredBuilds =
      target && target !== 'all'
        ? builds.filter(b => b.target === target)
        : builds

    if (builds.length === 0) {
      return (
        <EmptyState greedy>
          <Loading large />
        </EmptyState>
      )
    }

    return (
      <Page className="admin-users-page" title="Builds">
        <p>
          <Link to="/admin/users">← Back to Users</Link>
        </p>
        <h1>Builds</h1>
        <div>
          <div className="admin-build-options">
            <span>Filter by platform:</span>
            <WrappedSelect
              label="Platform"
              options={targetOptions}
              onChange={this.setTarget}
              value={target}
            />
          </div>
          <span>
            <a onClick={this.triggerRestart}>Restart</a> all unique builds that
            have failed in the last{' '}
            <input
              type="number"
              min={1}
              max={48}
              value={hoursBack}
              onChange={e => this.setState({ hoursBack: e.target.value })}
            />{' '}
            hours
          </span>
          {filteredBuilds.map(build => (
            <Build key={build.id} build={build} onRestart={restartBuild} />
          ))}
        </div>
      </Page>
    )
  }
}

const mapStateToProps = state => ({
  builds: getBuilds(state),
})

export default connect(mapStateToProps, {
  requestBuilds,
  restartBuild,
  restartFailedBuilds,
})(Builds)
